import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Observable} from 'rxjs';
import {Map} from 'leaflet';
import {first} from 'rxjs/operators';
import layersIcon from '@iconify/icons-mdi/layers-triple';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

export class MapLayersControlToolbar {
  private store: ArrayStore;

  constructor(store: ArrayStore) {
    this.store = store;
  }

  add(id: string | number, item: any) {
    item.id = id;
    this.store.insert(item);
  }

  disable(id: string | number) {
    this.store.update(id, {disabled: true});
  }

  enable(id: string | number) {
    this.store.update(id, {disabled: false});
  }


  show(id: string | number) {
    this.store.update(id, {visible: true});
  }

  hide(id: string | number) {
    this.store.update(id, {visible: false});
  }

  options(id: string | number, options: any) {
    this.store.push([
      {type: 'update', data: {options}, key: id},
    ]);
  }
}

@Component({
  selector: 'app-map-layers-control',
  templateUrl: './map-layers-control.component.html',
  styleUrls: ['./map-layers-control.component.scss']
})
export class MapLayersControlComponent implements OnInit {

  @Input()
  mapReady: Observable<Map>;

  map: Map;

  @Input()
  layers: any[];

  @Output()
  loaded = new EventEmitter<MapLayersControlToolbar>();

  readonly store: ArrayStore;
  readonly ds: DataSource;

  modeButtonOptions: any;
  private readonly modeButtonStore: ArrayStore;

  constructor() {

    this.store = new ArrayStore({
      data: [],
      key: 'id',
    });

    this.ds = new DataSource({
      store: this.store,
    });

    this.modeButtonStore = new ArrayStore({
      data: [],
      key: 'name',
    });

    this.modeButtonOptions = {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${layersIcon.body}</svg>`,
      text: 'Mode',
      hint: 'Changer le mode de la carte',
      dataSource: new DataSource({
        store: this.modeButtonStore,
        paginate: false,
      }),
      displayExpr: 'name',
      keyExpr: 'name',
      width: 125,
      stylingMode: 'text',
      useSelectMode: true,
      selectedItemKey: ['Satellite'],
      dropDownOptions: {
        onContentReady: (e: any) => {
          (e.component.content() as HTMLDivElement).classList.add('mode-submenu');
        }
      },
      onItemClick: async (e) => {
        this.layers.forEach(l => l.layer.remove());
        e.itemData.layer.addTo(this.map);
      }
    };

    this.store.insert({
      id: 'layers',
      location: 'center',
      locateInMenu: 'never',
      widget: 'dxDropDownButton',
      options: this.modeButtonOptions,
    });
  }

  ngOnInit(): void {
    this.mapReady.pipe(first()).subscribe((map) => {
      this.map = map;
      this.onMapReady(map);
    });
  }

  onMapReady(map: Map) {
    this.layers.forEach((l) => {
      this.modeButtonStore.insert(l);
    });

    this.loaded.emit(new MapLayersControlToolbar(this.store));
  }
}
